import PropTypes from "prop-types";
import { EffectFade, Mousewheel, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const StepSlider = ({ className, description, imgAlt, data, ...props }) => {
  return (
    <div className={` pt-10 lg:pt-24 ${className}`}>
      <div className="container">
        <Title
          text={data.title}
          as="h2"
          className=" mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-4xl"
        />
        {description ? (
          <p className="mb-10 text-center"> {description}</p>
        ) : null}
        <div className="row justify-center">
          <div className="col-12 mb-6 flex items-center justify-center lg:col-4 lg:mb-0 lg:justify-start">
            <Img
              src="/assets/images/offshore/country/bvi/bank_account-bvi.png"
              alt={imgAlt}
              width={351}
              height={350}
            />
          </div>
          <div className="col-12 order-3 flex items-center justify-center lg:col-1 lg:order-2">
            <div className="swiper-pagination-custom flex h-6 items-end justify-center lg:h-[370px] lg:w-fit lg:flex-col lg:pr-4"></div>
          </div>
          <div className="col-12 order-2 self-center lg:col-6 lg:order-3 ">
            <div>
              <Swiper
                slidesPerView={1}
                spaceBetween={30}
                mousewheel={true}
                allowTouchMove={true}
                effect={"fade"}
                fadeEffect={{
                  crossFade: true,
                }}
                pagination={{
                  el: ".swiper-pagination-custom",
                  clickable: true,
                  bulletClass: "pagination-bullet ",
                  bulletActiveClass:
                    "pagination-bullet-active bbc-pagination-bullet-active",
                }}
                breakpoints={{
                  320: {
                    allowTouchMove: true,
                  },
                  1024: {
                    allowTouchMove: true,
                  },
                }}
                modules={[Mousewheel, Pagination, EffectFade]}
                className="mySwiper"
                {...props}
              >
                {data.steps &&
                  data.steps.length > 0 &&
                  data.steps.map((step, index) => (
                    <SwiperSlide key={index} className="h-auto">
                      <div className="step-slider h-full rounded-xl bg-transparent p-0 lg:bg-white lg:px-10 lg:pb-10 lg:pt-6">
                        {/* <h3 className="mb-1 text-lg font-medium text-bbc-brand-700">
                          {step.index}
                        </h3> */}
                        <Title as="h3">
                          <span className="mb-1 block text-lg font-medium text-bbc-brand-700">
                            {step.index}
                          </span>
                          <span className="mb-6 block text-lg font-semibold text-bbc-brand-600 lg:text-2xl">
                            {step.titleStep}
                          </span>
                        </Title>
                        <div
                          className="text-bbc-gray"
                          dangerouslySetInnerHTML={{
                            __html: step.description,
                          }}
                        ></div>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepSlider;

StepSlider.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

StepSlider.defaultProps = {
  className: "",
};
